module.exports = __webpack_public_path__ + "img/logo_2_calizamar.da6e6949.png";